export const companyTypeListx = [
  { id: 6991, name: "INCORPORATED_TRUSTEE", description: "INCORPORATED TRUSTEE", classification_fk: 3 },
  { id: 6992, name: "LIMITED_BY_GUARANTEE", description: "LIMITED BY GUARANTEE", classification_fk: 2 },
  { id: 6993, name: "PRIVATE_COMPANY_LIMITED_BY_SHARES", description: "PRIVATE COMPANY LIMITED BY SHARES", classification_fk: 2 },
  { id: 6994, name: "PRIVATE_UNLIMITED_COMPANY", description: "PRIVATE UNLIMITED COMPANY", classification_fk: 2 },
  { id: 6995, name: "PUBLIC_COMPANY_LIMITED_BY_SHARES", description: "PUBLIC COMPANY LIMITED BY SHARES", classification_fk: 2 },
  { id: 6996, name: "PUBLIC_UNLIMITED_COMPANY", description: "PUBLIC COMPANY LIMITED BY SHARES", classification_fk: 2 },
  { id: 6997, name: "UNSPECIFIED", description: "UNSPECIFIED", classification_fk: 4 },
  { id: 6998, name: "PRIVATE_COMPANY_LIMITED_BY_GUARANTEE", description: "PRIVATE_COMPANY_LIMITED_BY_GUARANTEE", classification_fk: 2 },
  { id: 6999, name: "PUBLIC_COMPANY_LIMITED_BY_GUARANTEE", description: "PUBLIC_COMPANY_LIMITED_BY_GUARANTEE", classification_fk: 2 },
  { id: 7000, name: "BUSINESS_NAME_FIRM", description: "BUSINESS NAME - PARTNERSHIP", classification_fk: 1 },
  { id: 6990, name: "BUSINESS_NAME", description: "BUSINESS NAME - SOLE PROPRIETOR", classification_fk: 1 },
  { id: 7001, name: "LIMITED_LIABILITY_PARTNERSHIP", description: "LIMITED LIABILITY PARTNERSHIP", classification_fk: 5 },
  { id: 7002, name: "LIMITED_PARTNERSHIP", description: "LIMITED PARTNERSHIP", classification_fk: 4 },
];


export const companyTypeList: any[] =
  companyTypeListx.sort((a, b) => {
    if (a.name > b.name) {
      return 1;
    }
    if (a.name < b.name) {
      return -1;
    }
    return 0;
  })
